import styled from 'styled-components';

export default {
    MainContainer: styled.div`
         width: 100%;
    `,
    MainBox: styled.div.attrs({ className: 'main-box' })`
        max-width: 1220px;
        min-width: 320px;
        padding-left: 8px;
        padding-right: 8px;
        margin: 0 auto 50px;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        
        @media(min-width: 900px) {
          margin-bottom: 159px;
        }
        
        @media(min-width: 1200px) {
          margin-bottom: 259px;
        }
        
        @media (min-width: 1220px) {
            padding-left: 8px;
            padding-right: 8px;
        }
    `,
    MainHeaderContainer: styled.header.attrs({ className: 'main-header' })`
        display: flex;
        max-width: 1220px;
        min-width: 320px;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        flex-direction: column;
        
        margin-bottom: 38px;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: border-box;
        
        @media (min-width: 600px) {
            justify-content: space-between;
            flex-direction: row;
            padding: 43px 8px 35px;
            margin-bottom: 0;
        }
        @media (min-width: 700px) {
            padding-top: 86px;
            padding-bottom: 70px;
        }
        @media (min-width: 1220px) {
            padding-left: 0;
            padding-right: 0;
        }
    
`,
    MainHeader: styled.h1.attrs({ className: 'main-h1' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 32px;
        line-height: 110%;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        order: 2;
        color: #1A1A1A;
        font-weight: 400;
        text-align: center;
        margin-top: 0;
        margin-bottom: 0;
        padding: 0 24px;
        
        span{
          display: block;
        }
        
        @media (min-width: 600px) {
            width: initial;
            text-align: initial;
            order: 1;
            padding: 0;
            margin-bottom: 0;
            span{
                display: inline;
            }
        }
        
        @media (min-width: 700px) {
             font-size: 40px;
        }
    `,
    MainLogo: styled.a.attrs({ className: 'main-logo' })`
        width: 100%;
        height: auto;
        order: 1;
        justify-self: flex-start;
        margin-bottom: 33px;
        padding: 27px 24px 31px;
        position: relative;
        box-sizing: border-box;
        &:before{
          content: '';
          position: absolute;
          bottom:0;
          left: 0;
          width: 100%;
          background: #B9C0C2;
          opacity: 0.5;
          height: 1px;
        }
        @media (min-width: 600px) {
            width: max-content;
            order: 2;
            padding: 0;
            margin-bottom: 0;
            
            &:before{
              display: none;
            }
        }
    `,
    LogoImage: styled.img.attrs({ className: 'logo' })`
    `,

    GoBack: styled.div.attrs({ className: 'goBack' })`
        margin: 0 24px;
        
        @media(min-width: 600px){
          margin: 0 8px;
        }
        
    `,
    GoBackText: styled.div.attrs({ className: 'goBackText' })`
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.267361px;
        color: #5B6164;
        margin-bottom: 49px;
        text-align: left;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        
        @media(min-width: 700px) {
          font-size: 14px;
          line-height: 20px;
        }
    `,
};
